export const REQUIRED_NAME = 'Name  is required';
export const REQUIRED_REGISTRATION_CODE = 'Registration Code  is required';
export const REQUIRED_REPRESENTATIVES_NAME = 'Representative Name  is required';
export const REQUIRED_ROLE = 'Role  is required';
export const REQUIRED_BASED_ON_DOCUMENT = 'Based on Document  is required';
export const REQUIRED_BANK_NAME = 'Bank Name  is required';
export const REQUIRED_BANK_ADDRESS = 'Bank Address  is required';
export const REQUIRED_COUNTRY_NAME_ID = 'Country selection is required';
export const REQUIRED_BANK_CODE = 'Bank Code is required';
export const REQUIRED_BANK_ACCOUNT_NUMBER = 'Bank Account Number is required';
export const REQUIRED_COMPANY_ADDRESS = 'Company address  is required';
export const REQUIRED_FIELDS_LANGUAGE = 'Language selection is required';
export const REQUIRED_VAT_NUMBER = 'VAT number is required';
export const INVALID_VAT_NUMBER = 'VAT number must contain only uppercase letters and numbers';
export const REQUIRED_COUNTRY_NAME = 'Country name is required';
